import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0a23eb13"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "edit-page-ai-generation"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "ai-generation-top"
};
const _hoisted_4 = {
  class: "ai-generation-top-title"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ai-generation-top-title-text"
}, "AI Assistance", -1));
const _hoisted_6 = {
  class: "ai-generation-tabs"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "description"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1));
const _hoisted_10 = {
  key: 0,
  class: "subtitle",
  style: {
    "margin-top": "15px"
  }
};
const _hoisted_11 = {
  class: "action-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_ai_generation_tabs = _resolveComponent("ai-generation-tabs");
  const _component_ai_generation_product_data = _resolveComponent("ai-generation-product-data");
  const _component_ai_generation_categories_selection = _resolveComponent("ai-generation-categories-selection");
  const _component_app_button = _resolveComponent("app-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
    icon: "ai",
    color: "#4D4D4D"
  }), _hoisted_5]), _createElementVNode("div", {
    class: "ai-generation-top-close",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onClose && $options.onClose(...args))
  }, [_createVNode(_component_app_icon, {
    icon: "cross",
    size: "20",
    color: "#616161"
  })])]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_ai_generation_tabs, {
    modelValue: $data.current_tab,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.current_tab = $event),
    tabs: $data.tabs
  }, null, 8, ["modelValue", "tabs"])]), _createElementVNode("div", {
    class: _normalizeClass(['ai-generation-section', $options.productdataClass])
  }, [_createElementVNode("div", {
    class: _normalizeClass(['ai-generation-description', $options.productdataClass])
  }, [_createElementVNode("p", _hoisted_7, _toDisplayString($options.current_title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString($options.current_description), 1), _hoisted_9, $options.current_subtitle ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString($options.current_subtitle), 1)) : _createCommentVNode("", true)], 2), _withDirectives(_createVNode(_component_ai_generation_product_data, {
    all_versions_list: $props.all_versions_list,
    product: $props.product,
    content_amazon_link: $props.content_amazon_link,
    onChangeTab: $options.onChangeTab,
    onSelectedProduct: $options.onSelectedProductData,
    onUserInputAIGeneration: $options.handleUserInputAIGeneration,
    onUserProductTitle: $options.handleUserProductTitle,
    onInputDataType: $options.handleInpuDataType
  }, null, 8, ["all_versions_list", "product", "content_amazon_link", "onChangeTab", "onSelectedProduct", "onUserInputAIGeneration", "onUserProductTitle", "onInputDataType"]), [[_vShow, $data.current_tab == 'product_data']]), $data.current_tab === 'product_benefits' ? (_openBlock(), _createBlock(_component_ai_generation_categories_selection, {
    key: 0,
    ref: "aiGenerationCategoriesSelection",
    product: $props.product,
    selectedProductData: $options.getSelectedProductData,
    userInput: $options.getUserInputData,
    benefits_array: $data.benefits,
    usecases_array: $data.usecases,
    userProductTitle: $data.userProductTitle,
    onSelectedProductBenefits: $options.onSelectedProductBenefits,
    onCompetitors_benefits_and_usecases: $options.setCompetitorsBenefitsAndUsecases,
    onCategories: $options.setBenefits
  }, null, 8, ["product", "selectedProductData", "userInput", "benefits_array", "usecases_array", "userProductTitle", "onSelectedProductBenefits", "onCompetitors_benefits_and_usecases", "onCategories"])) : _createCommentVNode("", true), $data.current_tab === 'product_usecases' ? (_openBlock(), _createBlock(_component_ai_generation_categories_selection, {
    key: 1,
    ref: "aiGenerationCategoriesSelection",
    product: $props.product,
    selectedProductData: $options.getSelectedProductData,
    userInput: $options.getUserInputData,
    type: $data.current_tab,
    usecases_array: $data.usecases,
    competitors_array: $data.competitors,
    userProductTitle: $data.userProductTitle,
    onSelectedProductUseCases: $options.onSelectedProductUseCases,
    onCategories: $options.setUseCases
  }, null, 8, ["product", "selectedProductData", "userInput", "type", "usecases_array", "competitors_array", "userProductTitle", "onSelectedProductUseCases", "onCategories"])) : _createCommentVNode("", true)], 2)]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    onClick: $options.leftActionClick,
    disabled: $options.disableLeftAction,
    loading: $data.actions.leftLoading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($options.leftAction), 1)]),
    _: 1
  }, 8, ["onClick", "disabled", "loading"]), _createVNode(_component_app_button, {
    variant: "outline-primary",
    v2: "",
    onClick: $options.rightActionClick,
    loading: $data.actions.rightLoading,
    disabled: $options.disableRightAction
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($options.rightAction), 1)]),
    _: 1
  }, 8, ["onClick", "loading", "disabled"])])]);
}